import { combineReducers } from "redux";
import localeReducer, { LocaleState } from "../locales/localeSlice";
import authReducer, { AuthState } from "./auth/authSlice";
import modalReducer, { ModalState } from "./modal/modalSlice";
import accountsModalReducer, { AccountsModalState } from "./accountsModal";
import userReducer, { UserState } from "./user";
import userManagementReducer, { UserManagementState } from "./userManagement";
import OnBoardingReducer, {
  OnBoardingState,
} from "./onBoarding/onBoardingSlice";
import selectedProductReducer, {
  SelectedProduct,
  SelectedProductState,
} from "./products/productSlice";
import createPaymentLinkReducer, {
  PaymentLink,
} from "./products/createpaymentslice";
import selectedCharityReducer, {
  SelectedCharity,
} from "./products/charitySlice";
import formValuesReducer, { formValuesState } from "./formValues";
import loadingSpinnerSliceReducer, {
  loadingSpinnerSliceState,
} from "./loadingSpinner";
import tokenReducer, { TokenState } from "./token";

export interface RootState {
  locale: LocaleState;
  auth: AuthState;
  modal: ModalState;
  accountsModal: AccountsModalState;
  user: UserState;
  product: SelectedProduct;
  createpaymentlink: PaymentLink;
  charity: SelectedCharity;
  formValues: formValuesState;
  loadingSpinner: loadingSpinnerSliceState;
  userManagement: UserManagementState;
  products: SelectedProductState;
  token: TokenState;
  OnBoarding: OnBoardingState;
}

const rootReducer = combineReducers({
  locale: localeReducer,
  auth: authReducer,
  modal: modalReducer,
  accountsModal: accountsModalReducer,
  user: userReducer,
  products: selectedProductReducer,
  createpaymentlink: createPaymentLinkReducer,
  charity: selectedCharityReducer,
  formValues: formValuesReducer,
  loadingSpinner: loadingSpinnerSliceReducer,
  userManagement: userManagementReducer,
  token: tokenReducer,
  OnBoarding: OnBoardingReducer,
});

export default rootReducer;
